import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Sparkles, Crown, FileText } from "lucide-react";
import { useAuth } from "../lib/auth";
import { PricingCard } from "./pricing/PricingCard";
import { usePlanCheckout } from "./pricing/usePlanCheckout";

const PLANS = [
  {
    id: "natal_blueprint",
    name: "Natal Blueprint",
    price: "$4.40",
    priceSuffix: "One-time",
    tagline: "Your report + 3 more scans",
    icon: FileText,
    features: [
      "21-page personalized Natal Blueprint PDF — emailed instantly + downloadable forever",
      "Sun, Moon & Rising · 9 planetary-line chapters · your Money, Love & Healing cities",
      "8-day wellness journey + 12-month outlook",
      "Unlocks the why & how behind every city score",
      "3 additional city scans (6 total)",
    ],
    accent: "#C8A96E",
    ring: "from-[#C8A96E]/60 via-[#C8A96E]/20 to-transparent",
    ctaLabel: "Buy Blueprint",
    testId: "cta-natal-blueprint",
  },
  {
    id: "solar_return",
    name: "Solar Return · Year Pass",
    price: "$26.99",
    priceSuffix: "Yearly",
    tagline: "Unlimited cosmic scanning",
    icon: Sparkles,
    features: [
      "Unlimited city scans for 12 months",
      "All map interactions",
      "No session timers",
    ],
    accent: "#C8A96E",
    highlight: true,
    ring: "from-[#C8A96E] via-[#F5D77A]/60 to-[#C8A96E]",
    ctaLabel: "Go Unlimited",
    testId: "cta-solar-return",
  },
  {
    id: "infinity_lifetime",
    name: "9 Life-Path Infinity",
    price: "$80",
    priceSuffix: "Infinity · Lifetime",
    tagline: "Never pay again",
    icon: Crown,
    features: [
      "Permanent access · all features",
      "Unrestricted scanning",
      "VIP gold username in chats",
    ],
    accent: "#C8A96E",
    infinity: true,
    ring: "from-[#C8A96E]/80 via-[#C89B22]/40 to-[#C8A96E]/80",
    ctaLabel: "Claim Lifetime",
    testId: "cta-infinity",
  },
];

export default function PricingCTA({ compact = false, title = "Choose your celestial gate" }) {
  const { user } = useAuth();
  const { busy, purchase } = usePlanCheckout();
  const [stripeMode, setStripeMode] = useState("");
  useEffect(() => {
    let alive = true;
    api.get("/payments/config").then((r) => { if (alive) setStripeMode(r.data?.secret_key_kind || ""); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <div data-testid="pricing-cta-block">
      {!compact && (
        <div className="mb-6">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#C8A96E]">Paywall Gateway</div>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tighter mt-1">{title}</h2>
          <p className="text-sm text-[#A89C98] mt-2">Every tier unlocks the same golden aesthetic — pick your depth.</p>
        </div>
      )}

      <div className="grid md:grid-cols-3 gap-4">
        {PLANS.map((p) => <PricingCard key={p.id} p={p} user={user} busy={busy} onBuy={purchase} />)}
      </div>

      <p className="text-[9px] text-[#A89C98] text-center mt-3 uppercase tracking-widest" data-testid="pricing-stripe-mode">
        Secure Stripe checkout{stripeMode === "live" ? "" : stripeMode === "test" ? " · Test mode active" : stripeMode === "missing" ? " · Payments not configured" : ""}
      </p>
    </div>
  );
}
